import React from 'react';
import Image from 'next/image';
import { FormattedMessage, useIntl } from 'react-intl';

import { translations } from '@/locales';
import { REGISTRATION_URL } from '@chew/common/config';

import { Button } from '@chew/common/components/Button';
import { ForParentsArticleItem } from '@/components/ForParentsArticleItem';

import rose from './assets/first-article.jpg';
import firstArticle from './assets/first-article.jpg';
import thirdArticle from './assets/third-article.jpg';
import secondArticle from './assets/second-article.jpg';

const topWave = (
  <svg viewBox="0 0 375 52" fill="none" xmlns="http://www.w3.org/2000/svg" className="-mb-1">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0L15.625 8.66667C31.25 17.3333 62.5 34.6667 93.75 36.8333C125 39 156.25 26 187.5 21.6667C218.75 17.3333 250 21.6667 281.25 19.5C312.5 17.3333 343.75 8.66667 359.375 4.33333L375 0V52H359.375C343.75 52 312.5 52 281.25 52C250 52 218.75 52 187.5 52C156.25 52 125 52 93.75 52C62.5 52 31.25 52 15.625 52H0V0Z"
      fill="#DAE7E7"
    />
  </svg>
);

const bottomWave = (
  <svg viewBox="0 0 1440 68" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg-for-parents">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 51.5588L60.0417 45.0137C120.083 38.4687 240.167 25.3787 360.25 14.4703C480.333 3.56192 600.417 -5.16478 720.5 3.56192C840.583 12.2886 960.667 38.4687 1080.75 45.0137C1200.83 51.5588 1320.92 38.4687 1380.96 31.9237L1441 25.3787V68H1380.96C1320.92 68 1200.83 68 1080.75 68C960.667 68 840.583 68 720.5 68C600.417 68 480.333 68 360.25 68C240.167 68 120.083 68 60.0417 68H0V51.5588Z"
      fill="white"
    />
  </svg>
);

const muffin = (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 59" className="h-20">
    <path
      d="M47.246 21.646c-.745-6.932-6.682-12.77-13.572-13.79-8.152-1.205-16.883 3.206-20.021 10.977-1.516 3.75-1.86 8.308.048 11.963-5.124 1.902-8.194 7.595-6.003 12.903 1.991 4.819 7.928 6.927 12.47 4.604.833 3.119 1.536 6.33 2.638 9.363.567 1.561 1.678 1.213 3.197 1.093 2.41-.19 4.813-.52 7.192-.944 4.322-.771 8.64-1.83 12.76-3.36 1.696-.63 5.453-1.577 5.388-3.852-.084-2.985-.92-6.025-1.519-8.961 5.474-.399 10.089-4.064 10.358-9.936.165-3.592-1.157-7.021-4.102-9.187-2.572-1.89-6.075-2.362-8.835-.874l.001.001Zm-22.65 35.565c.067.048.058.17 0 0ZM58.222 32.76c-.767 4.838-5.24 7.199-9.811 7.059-1.004-.031-1.172 1.27-.497 1.712.49 2.543 1.037 5.077 1.412 7.64.07.485.061 1.016.163 1.491.005.016.004.04.005.065-.078.052-.208.177-.312.227-1.099.526-2.136 1.107-3.283 1.547-3.459 1.328-7.074 2.278-10.696 3.037a77.667 77.667 0 0 1-6.464 1.088 62.637 62.637 0 0 1-3.14.307c-.207.014-.413.029-.62.04l-.205.013a1.68 1.68 0 0 0-.25-.034c-.76-3.155-1.795-6.28-2.642-9.416a.95.95 0 0 0-.165-.338c.457-.777-.36-1.95-1.198-1.313-3.674 2.798-9.221 1.511-11.073-2.77-2.04-4.715 1.127-9.72 5.891-10.885.559-.136.896-.868.56-1.366-4.217-6.247-.151-14.908 5.58-18.58 6.002-3.847 14.206-3.849 19.553 1.142 2.77 2.586 4.513 6.133 4.432 9.956-.017.835 1.014 1.201 1.588.66 2.523-2.377 6.451-1.57 8.766.668 2.156 2.086 2.865 5.134 2.404 8.048l.002.002Z"
      fill="#AFCBCB"
    />
    <path
      d="M49.182 13.574c-.375.648-.994 1.114-1.596 1.539a.196.196 0 0 0 .097.362c.733.066 1.502.16 2.151.535.648.374 1.115.993 1.539 1.594.113.16.344.098.362-.097.066-.734.161-1.502.535-2.15.37-.639.975-1.1 1.568-1.52.094-.027.13-.13.109-.223l-.003-.011-.004-.014c-.028-.09-.11-.16-.205-.137-.723-.066-1.479-.164-2.118-.532-.648-.374-1.115-.994-1.538-1.594-.113-.16-.343-.099-.362.097-.066.733-.161 1.501-.536 2.15Zm.868-1.63c.288.383.603.75.98 1.043.452.353.974.57 1.533.69.226.05.455.084.684.113-.382.287-.75.602-1.043.979-.353.452-.57.975-.69 1.534-.05.225-.084.454-.113.683-.287-.382-.602-.75-.979-1.043-.452-.353-.974-.569-1.533-.69a7.617 7.617 0 0 0-.684-.112c.382-.287.75-.602 1.043-.98.353-.452.57-.974.69-1.533.05-.226.084-.454.112-.684ZM53.696 5.43a1.481 1.481 0 0 0-1.461.849 1.49 1.49 0 0 0 .316 1.682 1.492 1.492 0 0 0 1.67.259c.632-.303.944-1.035.774-1.704a1.491 1.491 0 0 0-1.3-1.087Zm.547 2.421c-.406.282-.95.28-1.352-.007a1.176 1.176 0 0 1-.438-1.277c.135-.46.556-.803 1.036-.834a1.18 1.18 0 0 1 1.209.861c.119.467-.052.978-.454 1.256l-.001.001ZM14.314 56.315a.271.271 0 0 0-.188.327l.341 1.273c.036.135.19.233.326.188a.271.271 0 0 0 .189-.326l-.341-1.273c-.037-.136-.19-.234-.327-.189ZM13.406 52.925a.271.271 0 0 0-.189.326l.364 1.359c.037.135.19.233.327.188a.271.271 0 0 0 .188-.326l-.364-1.359c-.036-.135-.19-.233-.326-.188ZM12.973 55.54l-1.274.342c-.135.036-.233.19-.188.327a.27.27 0 0 0 .326.188l1.274-.341c.135-.037.233-.19.188-.327a.27.27 0 0 0-.326-.188ZM16.362 54.633l-1.358.364c-.136.036-.234.189-.189.326a.27.27 0 0 0 .327.189l1.358-.364c.135-.037.233-.19.188-.327a.27.27 0 0 0-.326-.188ZM47.567 10.25a.18.18 0 0 0 .125-.216l-.226-.845c-.024-.09-.126-.154-.217-.125a.18.18 0 0 0-.126.217l.227.845c.024.09.125.153.217.125ZM46.979 8.057a.18.18 0 0 0 .125-.217l-.241-.901c-.024-.09-.126-.154-.217-.125a.18.18 0 0 0-.126.217l.242.901c.024.09.126.154.217.125ZM45.604 9.118l.845-.227c.09-.024.154-.125.125-.217a.18.18 0 0 0-.217-.125l-.845.226c-.09.024-.154.126-.125.217a.18.18 0 0 0 .217.126ZM47.797 8.53l.902-.242c.09-.024.153-.125.125-.217a.18.18 0 0 0-.217-.125l-.902.242c-.09.024-.154.125-.125.217a.18.18 0 0 0 .217.125ZM40.547 41.202c-1.563 1.777-4 1.866-5.652.141-.513-.534-1.325-.214-1.548.415-1.518 4.273-6.72 4.23-10.099 2.437-1.054-.56-1.986 1.045-.927 1.606 4.148 2.202 9.85 1.959 12.255-2.313 2.29 1.529 5.37 1.204 7.292-.981.785-.893-.527-2.206-1.32-1.306h-.001ZM45.007 36.801c-.535-.122-.951.167-1.14.65l-.53 1.35c-.178.453.197 1.038.65 1.14.534.123.95-.166 1.14-.65l.53-1.349c.178-.453-.198-1.037-.65-1.14Z"
      fill="#AFCBCB"
    />
  </svg>
);

export const ForParentsSection: React.FC = () => {
  const intl = useIntl();

  const text = translations.pages.landing.forParentsSection;

  return (
    <section className="my-12 flex w-full flex-col" id="parents">
      <div className="-mb-16 ml-10 md:ml-20 md:-mb-24 z-10">{muffin}</div>
      {topWave}

      <div className="bg-for-parents flex flex-col text-center px-4 pt-6 xs:pt-0 items-center">
        <div className="text-sectionTitle font-extrabold">
          <FormattedMessage id={text.title} />
        </div>

        <div className="text-header mt-4 max-w-lg">
          <FormattedMessage id={text.subtitle} />
        </div>

        <div className="flex flex-col md:flex-row md:flex-wrap md:space-y-0 md:gap-3 space-y-3 w-full my-10 md:justify-center">
          <ForParentsArticleItem
            imageUrl={firstArticle}
            title={intl.formatMessage({ id: text.articles.first.title })}
            description={intl.formatMessage({ id: text.articles.first.description })}
            url="https://www.facebook.com/story.php?story_fbid=pfbid0kZFvjEyXgbxEms6DJx6XBw7UywLuJWMpm2Qm3CQwA89ddYFCimoHH6dVDgWHXKSil&id=106906654775795&mibextid=8qvjqc"
          />

          <ForParentsArticleItem
            imageUrl={secondArticle}
            title={intl.formatMessage({ id: text.articles.second.title })}
            description={intl.formatMessage({ id: text.articles.second.description })}
            url="https://www.facebook.com/story.php?story_fbid=pfbid02YzvcAosc5jB1dqjvgwJv33okHnnCGxVko3eHMaBCMPNQRcF8QzTRTu5a3Sv1eXThl&id=106906654775795&mibextid=8qvjqc"
          />

          <ForParentsArticleItem
            imageUrl={thirdArticle}
            title={intl.formatMessage({ id: text.articles.third.title })}
            description={intl.formatMessage({ id: text.articles.third.description })}
            url="https://www.facebook.com/story.php?story_fbid=pfbid0XEvY6jrGR3LsDskH2V43Rmn44P9dVu9gMZHeZWm8W1yhrp6mCdxRs4Q3o2ZfsM3vl&id=106906654775795&mibextid=8qvjqc"
          />
        </div>

        <div className="flex">
          <div className="rounded-full relative overflow-hidden h-20 w-20">
            <Image src={rose} alt="Photo of our nutritionist Rose" layout="fill" />
          </div>

          <div className="flex flex-col justify-center items-start ml-4">
            <div className="text-2xl font-extrabold">
              <FormattedMessage id={text.nutritionist.name} />
            </div>

            <div className="text-purple-medium">
              <FormattedMessage id={text.nutritionist.title} />
            </div>
          </div>
        </div>

        <div className="mt-6 max-w-sm sm:max-w-lg">
          <FormattedMessage id={text.description} />
        </div>

        <Button
          onClick={() => window.open(REGISTRATION_URL, '_self')}
          appearance="gradient-orange"
          fat
          className="px-12 mt-10 mb-10 text-2xl"
        >
          <FormattedMessage id={translations.inputs.buttons.tryFree} />
        </Button>
      </div>

      {bottomWave}
    </section>
  );
};
